import { cn } from '@latitude/token-utils';
import { forwardRef } from 'react';
import type { PropsWithChildren } from 'react';
import { bodyVariants } from 'variants/body-footer-variants';

/**
 * Props for the Body component.
 * @property className - Additional class name for the body.
 * @property animateHeight - Sizes from an explicit height and transitions it.
 */
type Props = {
  className?: string;
  animateHeight?: boolean;
} & PropsWithChildren;

/**
 * Body component of the modal.
 */
export const Body = forwardRef<HTMLDivElement, Props>(
  ({ children, className, animateHeight }, ref) => (
    <div
      ref={ref}
      data-testid="modal-body"
      className={cn(bodyVariants({ animateHeight }), className)}
    >
      {children}
    </div>
  ),
);

Body.displayName = 'Body';
